export interface AgreementReceiptEmailPayload {
  invoice_id: string | number;
  accountid: string | number;
  emails: string[];
  shouldSendAll: false;
}

interface BuildAgreementReceiptEmailPayloadParams {
  isPaymentSuccessful: boolean;
  isRealTimePayment: boolean;
  invoiceId?: string | number | null;
  accountId?: string | number | null;
  emails?: string | string[] | null;
}

const normalizeEmails = (emails?: string | string[] | null): string[] => {
  const emailList = Array.isArray(emails) ? emails : [emails];

  return Array.from(
    new Set(
      emailList
        .map((email) => (typeof email === "string" ? email.trim() : ""))
        .filter(Boolean)
    )
  );
};

export const buildAgreementReceiptEmailPayload = ({
  isPaymentSuccessful,
  isRealTimePayment,
  invoiceId,
  accountId,
  emails,
}: BuildAgreementReceiptEmailPayloadParams): AgreementReceiptEmailPayload | null => {
  const normalizedInvoiceId =
    typeof invoiceId === "string" ? invoiceId.trim() : invoiceId;
  const normalizedAccountId =
    typeof accountId === "string" ? accountId.trim() : accountId;
  const normalizedEmails = normalizeEmails(emails);

  if (
    !isPaymentSuccessful ||
    !isRealTimePayment ||
    !normalizedInvoiceId ||
    !normalizedAccountId ||
    normalizedEmails.length === 0
  ) {
    return null;
  }

  return {
    invoice_id: normalizedInvoiceId,
    accountid: normalizedAccountId,
    emails: normalizedEmails,
    shouldSendAll: false,
  };
};
